import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import LabeledValue from "./controls/LabeledValue";
import ListValue from "./controls/ListValue";
import MeasureValue from "./controls/MeasureValue";
import TextValue from "./controls/TextValue";

export function ResiduoPeligrosoList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((item, index) => (
        <ListGroupObjectItem
          index={index}
          indexLabel={t("residuoPeligroso.orden")}
          value={item}
          editable
          onEdit={(event) => {
            event.preventDefault();
            select(index);
            document.getElementById("residuosPeligrosos").scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}
          deletable
          onDelete={(event) => {
            event.preventDefault();
            remove(index);
          }}
          disabled={disabled}
        >
          {({ value }) => (
            <Grid>
              <Row>
                <Col>
                  <LabeledValue
                    label={t("residuoPeligroso.corriente")}
                    value={value?.corriente}
                    labelAttr={(value) => `${value.codigo} ${value.nombre}`}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <ListValue
                    label={t("residuoPeligroso.peligrosidad")}
                    value={value?.peligrosidad}
                    labelAttr={(value) => `${value.codigo} ${value.nombre}`}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <MeasureValue
                    label={t("residuoPeligroso.cantidad")}
                    value={value?.cantidad}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <ListValue
                    label={t("residuoPeligroso.operacionesUnitarias")}
                    value={value?.operacionesUnitarias}
                    labelAttr="nombre"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextValue
                    label={t("residuoPeligroso.descripcion")}
                    value={value?.descripcion}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabeledValue
                    label={t("residuoPeligroso.tratamiento")}
                    value={value?.tratamiento}
                    labelAttr="nombre"
                  />
                </Col>
              </Row>
            </Grid>
          )}
        </ListGroupObjectItem>
      ))}
    </ListGroup>
  );
}
